import accountMenuBtn from '../../images/docs/account-bar-edit.png';
import createAccBtn from '../../images/docs/sign-in-edit.png';
import registerBtn from '../../images/docs/register-edit.png';
import profileBtn from '../../images/docs/profil-edit.png';
import addressBtn from '../../images/docs/profil-save-edit.png';
import signOutBtn from '../../images/docs/theme-sign-signout-edit.png';

export const meta = {
  slug: 'cont',
  title: 'Cont',
  description: 'Crearea, editarea și gestionarea contului dvs. pe platforma Programintrastat.ro.',
  icon: 'user',
  order: 3,
  related: ['abonamente', 'introducere'],
};

export const images = { accountMenuBtn, createAccBtn, registerBtn, profileBtn, addressBtn, signOutBtn };

export const content = `
## Cont

### 1. Creare cont

Pentru a crea un cont trebuie să navigați întâi la secțiunea "Cont" <span class="dot">1</span>

::image[accountMenuBtn]{alt="Butonul meniului cont"}

Veți ajunge în meniul "Intra în cont". De aici puteți să vă autentificați cu contul dvs. odată ce îl creați. Pentru a crea un cont nou, din acest meniu va trebui să navigați către "Creare cont" <span class="dot">2</span>

::image[createAccBtn]{alt="Butonul creare cont"}

Astfel veți ajunge în meniul "Creare cont". Odată ce veți completa corect formularul de pe această pagină puteți naviga în josul acestuia și să dați click pe butonul "Creare cont" <span class="dot">3</span>

::image[registerBtn]{alt="Butonul de înregistrare"}

Dacă ați urmărit acești pași corect ar trebui să fiți redirecționați pe pagina principală a platformei Programintrastat.ro. Pentru a putea utiliza apoi platforma Programintrastat.ro va trebui să vă activați contul dând click pe linkul primit pe email. În cazul în care au apărut erori la crearea contului puteți încerca:

- Să urmați pașii din eroare (dacă există).
- Să verificați corectitudinea adresei de email.
- Să verificați corectitudinea datelor din formularul de înregistrare.
- Să vă asigurați că sunteți conectat la internet.
- În ultimă instanță ne puteți contacta la adresa [programintrastat@gmail.com](mailto:programintrastat@gmail.com) sau prin formularul de contact de pe site.

### 2. Editare cont

Pentru a vă edita contul trebuie întâi să fiți autentificat. Puteți face acest lucru din meniul "Cont". Urmăriți pasul anterior pentru mai multe detalii. Odată autentificat, navigați către meniul "Profil" <span class="dot">1</span>

::image[profileBtn]{alt="Butonul principal profil"}

Din această pagină puteți modifica atât datele personale cât și datele firmei. După ce ați modificat detaliile dorite apăsați butonul "Salvează" <span class="dot">2</span> de sub formularul cu datele schimbate (Date personale sau Date companie).

::image[addressBtn]{alt="Salvare profil actualizat"}

### 3. Ieșire din cont (Delogare)

Pentru a ieși din cont tot ce trebuie să faceți este să apăsați butonul roșu din colțul dreapta de sus al ecranului.
`;
